import { mapActions } from 'vuex';
import queryBuilder from '@/helpers/search-client/query-builder/query';
import { debounce, isEqual } from '@/helpers/utilities';

export default {
  computed: {
    searchCriteria() {
      if (!this.state('search')) return false;
      return this.state('search.searchCriteria');
    },
    sectionCustomQuery() {
      if (!this.state('search')) return false;
      return this.state('search.sectionCustomQuery');
    },
  },
  watch: {
    searchCriteria: debounce(async function deb(val, oldVal) {
      if (!this.state('search')) return;
      if (!oldVal || isEqual(val, oldVal)) return;
      await this.updateSearch(val);
    }, 300),
  },
  methods: {
    ...mapActions('ndc/search', ['getVehicles', 'updateFiltersCounts']),
    async updateSearch(val) {
      const currentPage = this.state('search.currentPage');
      const version = this.state('search.version');

      this.changeSearchParamsUrl({
        updateSearchParams: val,
        updatePageParam: null,
        updateVersion: version,
      });

      await this.updateFiltersCounts();

      // load all vehicles if page size is more than 1
      if (currentPage === 1) {
        await this.dispatch('search/getVehicles');
      } else {
        await this.dispatch('search/getVehiclesWithPageSize');
      }
    },

    changeSearchParamsUrl({
      updateSearchParams,
      updateSortParams,
      updatePageParam,
      updateLocation,
      updateVersion,
    }) {
      const version = this.state('search.version');
      return queryBuilder.changeUrlParamsHelper({
        updateSearchParams,
        updateSortParams,
        updatePageParam,
        updateLocation,
        updateVersion: updateVersion || version || null,
      });
    },
  },
};
